require('./cardShowAndHideSensitiveInformation.scss');
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { OKLink } = require('commonsComponents/OKLink');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const {FormattedText} = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');


class CardShowAndHideSensitiveInformationExpired extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleNewRequest = this.handleNewRequest.bind(this);
        this.handleNavigate = this.handleNavigate.bind(this);
    }

    handleNewRequest(){
        this.props.triggerNewRequest(this.props.cardId);
    }

    handleNavigate(){
        const { history } = this.props;
        history.goBack()
    }

    render() {
        const {title, messageExpired, textBack } = this.props;

        return (
            <div className="code-confirmation-success__container">
                <div className="code-confirmation-success__title">
                    {title}
                </div>
                <div className="code-confirmation-success__code code-confirmation-success__code--expired">
                </div>
                <div className="code-confirmation-success__label">
                    {messageExpired}
                </div>
                <div className="code-confirmation-success__label">
                    <FormattedText value="cardRequests-newRequestMessage" />
                    <OKButton
                        modifier="link-emphasize"
                        onClick={this.handleNewRequest}
                        id="btn_card_requests_new_request"
                    >
                        <FormattedText value="cardRequests-newRequestLink" />
                    </OKButton>
                </div>
                <div className="code-confirmation-success__footer">
                    <OKLink
                        modifier="emphasize"
                        onClick={this.handleNavigate}
                    >
                        {textBack}
                    </OKLink>
                </div>
            </div>
        );
    }
}

CardShowAndHideSensitiveInformationExpired.propTypes = {
    cardId: PropTypes.string.isRequired,
    triggerNewRequest: PropTypes.func.isRequired,
    title: PropTypes.string,
    textBack: PropTypes.string,
    messageExpired: PropTypes.string,
    history: PropTypes.object
};

module.exports = withRouter(CardShowAndHideSensitiveInformationExpired);
